import React, { useState } from 'react';

import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import { Alert, Box, Button, Paper, Typography } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import { Bundle } from '~/types/bundles/bundle';

import BundleDepartureChecks from './BundleDepartureChecks';
import TourComponentDialog from './TourComponentDialog';
import useBundleTourSpan from './useBundleTourSpan';

interface Props {
  bundle: Bundle;
}

export default function BundleDeparturesStep({ bundle }: Props) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { tour } = useBundleTourSpan(bundle);
  const isDraft = bundle.status === 'draft';

  return (
    <Box>
      <PageSubheader title="Departures">
        {isDraft && !!tour && (
          <Box pb={1}>
            <Button startIcon={<EditCalendarIcon />} onClick={() => setIsDialogOpen(true)}>
              Edit departures
            </Button>
          </Box>
        )}
      </PageSubheader>

      <Typography color="text.secondary" mb={2}>
        Every departure the bundle sells, checked for a single and a double on the tour and on each hotel's check-in.
      </Typography>

      {!tour && <Alert severity="info">Add the tour first. Its departures are the ones the bundle can sell.</Alert>}

      {!!tour && bundle.departure_dates.length === 0 && (
        <Paper variant="outlined" sx={{ borderStyle: 'dashed', p: 4, textAlign: 'center' }}>
          <Typography variant="h6">No departures selected yet</Typography>
          <Typography color="text.secondary" mb={2}>
            Choose which of the tour's departures this bundle sells.
          </Typography>
          {isDraft && (
            <Button variant="contained" startIcon={<EditCalendarIcon />} onClick={() => setIsDialogOpen(true)}>
              Choose departures
            </Button>
          )}
        </Paper>
      )}

      <BundleDepartureChecks bundle={bundle} />

      {!!tour && (
        <TourComponentDialog
          bundle={bundle}
          component={tour}
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </Box>
  );
}
